import {Model} from '@/models/Model'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import Helper from '../services/Helper.js'


export const TransportRouteConst = Object.freeze({

})


export class TransportRoute extends Model {
  declare id: number | null
  created_at: Date | null
  updated_at: Date | null
  name: string | null
  enabled: boolean | null
  remark: string | null
  status: string | null
  city_enabled: []

  getResourceURL(): string {
    return Helper.setting.transportRoute.getResourceAPI
  }


}

export class DataTransportRoutesArray extends DataArray {

  declare data: TransportRoute[]
  filter: FilterTransportRoute = new FilterTransportRoute()
}


export class FilterTransportRoute {
  price_group: FilterSet = new FilterSet()
}


export class DataTransportRoute extends DataResource {

  declare data: TransportRoute

}
